<template>
    <v-dialog :modelValue="modelValue" @update:modelValue="$emit('update:modelValue', false)" scroll-strategy="none">

        <v-card elevation="0" :width="520" style="padding: 20px; height: fit-content;">
            <v-card-title> <span class="title">{{ $t('ProductType.create') }}</span></v-card-title>
            <v-card-title class="text-left">{{ $t('ProductType.Name') }}<span class="red">*</span></v-card-title>
            <v-text-field v-model="ProductTypeName" id="Title" name="Title" maxlength="30" hide-details
                persistent-placeholder variant="outlined" class="rounded-xl input-field"
                :placeholder="$t('placeholder.enter', { itm: $t('Brands.PlaceHolderTags.Name') })"></v-text-field>
            <span class="warningHint" id="WarningMsgReference">{{ msg.ProductTypeName }}</span>

            <v-card-title class="text-left">{{ $t('ProductType.Category') }}<span class="red">*</span></v-card-title>
            <v-autocomplete v-model="selectedCategory" :items="productTypeCategories" item-title="name"
                item-value="value" variant="outlined" persistent-placeholder
                :placeholder="$t('placeholder.select', { itm: $t('ProductType.Category') })" hide-details
                class="rounded-xl input-field">
                <template v-slot:item="{ props, item }">
                    <v-list-item v-bind="props" :value="item.value">
                        <v-list-item-title class="category-item">{{ item.name }}</v-list-item-title>
                    </v-list-item>
                </template>
            </v-autocomplete>
            <span class="warningHint" id="WarningMsgCategory">{{ msg.Category }}</span>

            <genericBtnComponent :disabled="loader" :ClickFun="validateProductType" svg="5"
                :Title="$t('purchaseOrder.save')" :loader="loader" />
        </v-card>
    </v-dialog>
</template>
<script>
import genericBtnComponent from "@/genericComponent/genericBtnComponent.vue"
import { CreateProductType } from "@/api/index";
export default {
    components: {
        genericBtnComponent
    },
    props: {
        modelValue: { type: Boolean },
    },
    mounted() {
        document.title = window.VUE_APP_NAME + ' - ' + this.$t('Document.Title.Brands');
    },
    computed: {
        productTypeCategories() {
            return [
                { name: this.$t('ProductType.Categories.Standard'), value: 0 },
                { name: this.$t('ProductType.Categories.Perishable'), value: 1 },
                { name: this.$t('ProductType.Categories.Fragile'), value: 2 },
                { name: this.$t('ProductType.Categories.Hazardous'), value: 3 },
                { name: this.$t('ProductType.Categories.Oversized'), value: 4 }
            ];
        },
    },
    data: () => ({
        msg: [],
        loader: false,
        ProductTypeName: null,
        selectedCategory: null,
    }),
    methods: {
        ActiveWarningSnackBar() {
            this.getParent('MainLayout').ActiveWarningSnackBar();
        },
        ActiveSavedSnackBar() {
            this.getParent('MainLayout').ActiveSavedSnackBar();
        },
        getParent(name) {
            let p = this.$parent;
            while (typeof p !== 'undefined') {
                if (p.$options.name == name) {
                    return p;
                } else {
                    p = p.$parent;
                }
            }
            return false;
        },
        async validateProductType() {
            this.loader = true
            if (!this.ProductTypeName || this.ProductTypeName.length == 0) {
                this.msg["ProductTypeName"] = this.$t('warningInput.isrequired', { itm: this.$t('ProductType.Name') });
                this.loader = false;
                return;
            }

            if (!this.selectedCategory && this.selectedCategory !== 0) {
                this.msg["Category"] = this.$t('warningInput.isrequired', { itm: this.$t('ProductType.Category') });
                this.loader = false;
                return;
            }

            this.msg["ProductTypeName"] = "";
            this.msg["Category"] = "";

            try {
                await CreateProductType(this.ProductTypeName, this.selectedCategory);
                this.ActiveSavedSnackBar();
                this.ProductTypeName = null;
                this.selectedCategory = null;
                this.$emit('refresh');
                this.$emit('update:modelValue', false);
            } catch (error) {
                this.ActiveWarningSnackBar();
            } finally {
                this.loader = false;
            }
        }
    },
};
</script>

<style scoped>
.title {
    margin-top: auto;
    font-size: 18px;
    line-height: 25.5px;
    font-weight: 700;
    font-family: inter;
    width: 100%;
    text-align: center;
}

.v-card-title {
    font-family: inter;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    color: #5b6d8e;
    margin-left: 12px;
    padding-left: 0;
    margin-top: 0;
    padding-top: 0;
}

.input-field {
    width: 95%;
    margin-left: 12px;
}

.category-item {
    color: #000;
    font-family: inter;
    font-size: 14px;
}

.v-list-item {
    min-height: 44px;
}

.v-list-item-title {
    color: #000;
    padding: 8px;
}
</style>